import { useQuery } from '@tanstack/react-query';
import { getRenewalOffer } from '@/api/renewal-offer.api';

export const renewalOfferKeys = {
  forStartup: (startupId: string) => ['renewal-offer', startupId] as const,
};

/**
 * The data room renewal offer for a startup (MYN-247). Disabled without a
 * startup or for a caller without `billing.manage`, whom the API would refuse.
 *
 * @param startupId - the startup entity, or null
 * @param enabled - false for a caller who may not buy
 */
export function useRenewalOffer(startupId: string | null, enabled = true) {
  return useQuery({
    queryKey: renewalOfferKeys.forStartup(startupId ?? ''),
    queryFn: () => getRenewalOffer(startupId as string),
    enabled: Boolean(startupId) && enabled,
  });
}
